import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTelevisie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M35 11H5v18h30z"
    />
    <path
      fill="#FFBFA5"
      d="M33.5 12.5h-27v15h27z"
    />
    <path
      fill="#FF7842"
      d="M27 30H13v1h14z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.68 19.93 15 25.69l-.54-.72 7.68-5.76zM25.54 15.84l-9.05 6.79-.54-.72L25 15.12zM7.4 9.31h4.45v.9H8.3v6.51h-.9z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M35.653 22.292 30.82 21.01l-2.819 10.633 4.833 1.281z"
    />
    <path
      fill="#FFBFA5"
      d="m32.513 22.669-.97-.26-.26.97.97.26zM34.46 23.198l-.97-.26-.26.97.97.26zM31.994 24.618l-.97-.26-.26.97.97.26zM33.933 25.135l-.97-.26-.26.97.97.26zM31.477 26.548l-.97-.26-.26.97.97.26zM33.403 26.86l-.967-.256-.256.966.966.256zM30.44 30.219l-.966-.256-.256.966.966.257zM32.371 30.953l-.97-.26-.26.97.97.26zM32.894 29.009l-2.91-.78-.26.97 2.91.78z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTelevisie);

export default ForwardRef;
